import {TrackingClientStateHolder} from './providers/gtm/helpers/clientState';
import {
  ShouldPushToDataLayerObject,
  shouldPushToDataLayerObject,
} from './providers/gtm/helpers/datalayer';

export class TrackingClient {
  private state: TrackingClientStateHolder;
  constructor(state: TrackingClientStateHolder) {
    this.state = state;
  }

  track = (
    trackingFn: (
      state: TrackingClientStateHolder
    ) => ShouldPushToDataLayerObject | ShouldPushToDataLayerObject[]
  ) => {
    const event = trackingFn(this.state);

    if (Array.isArray(event)) {
      event.forEach(e => shouldPushToDataLayerObject(e, this.state));
    } else {
      shouldPushToDataLayerObject(event, this.state);
    }
  };

  trackWithoutPushToDataLayer = (
    trackingFn: (
      state: TrackingClientStateHolder
    ) => ShouldPushToDataLayerObject
  ) => {
    trackingFn(this.state);
  };
}
